import styles from './style.module.scss';
import {IMedium} from "../../../../models/medium/response";
interface IProps {
  file?: IMedium | string;
  text?: string;
  date?: string;
  name?: string;
  isLeft?: boolean;
  isAudio?: boolean;
  id?: number; 
  userType?: string;
  phone?: string;
  status?: "sending" | "sent" | "failed";

}

const MessageCart = ({
  file,
  text,
  isLeft,
  isAudio = false,
  id = 0, 
  date,
  name,
  userType,
  status
}: IProps) => {
  
  // Helper function to ensure URL has the correct prefix
  const processFileUrl = (url: string): string => {
    const baseUrl = "https://dev.3l-hareek.com/storage/media/messages/MessageFiles/";
    
    // If URL already has the prefix, return as is
    if (url.startsWith(baseUrl)) {
      return url;
    }
    
    // If URL already starts with https://, return as is (external URL)
    if (url.startsWith("https://") || url.startsWith("http://")) {
      return url;
    }
    
    // Add the prefix to relative URLs
    return baseUrl + url;
  };
  
  // ✅ إضافة logging للتشخيص
  console.log("🔍 MessageCart render:", { 
    id, 
    file, 
    fileType: typeof file, 
    hasUrl: file && typeof file === 'object' ? !!file.url : null,
    fileUrl: typeof file === 'string' ? file : (file && typeof file === 'object' ? file.url : null)
  });

  const renderFile = () => {
    if (!file) {
      console.log("❌ No file to render");
      return null;
    }

    // ✅ إذا كان file string URL (من الرسالة المحلية أو الخادم)
    if (typeof file === 'string') {
        const fileUrl = processFileUrl(file);

      // ✅ التحقق من أن الملف يحتوي على URL صحيح
      if (!fileUrl || fileUrl === 'null' || fileUrl === 'undefined') {
        console.log("❌ Invalid file URL:", fileUrl);
        return null;
      }
      
      console.log("✅ Rendering string file:", fileUrl);
      const fileExtension = fileUrl.split('.').pop()?.toLowerCase() || '';
      
      // Check if the file is an image
      const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif'].includes(fileExtension);

      if (isImage) {
        return (
          <img
            src={fileUrl}
            alt="Uploaded file"
            style={{ maxWidth: "100%", borderRadius: "10px", marginTop: "10px" }}
            onError={(e) => {
              console.error("❌ Failed to load image:", fileUrl);
              // يمكن إضافة fallback هنا
            }}
            onLoad={() => {
              console.log("✅ Image loaded successfully:", fileUrl);
            }}
          />
        );
      } else {
        // For PDFs or other file types, show a download link
        return (
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: isLeft ? "#000" : "#fff",
              textDecoration: "underline",
              display: "block",
              marginTop: "10px",
            }}
          >
            Download File
          </a>
        );
      }
    }

    if (typeof file === 'object' && file.url) {
      const fileUrl = processFileUrl(file.url);
      const fileExtension = file.extension; // Get the file extension

      console.log("✅ Rendering IMedium file with URL:", fileUrl);

      // Check if the file is an image
      const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif'].includes(fileExtension || '');

      if (isImage) {
        return (
          <img
            src={fileUrl}
            alt="Uploaded file"
            style={{ maxWidth: "100%", borderRadius: "10px", marginTop: "10px" }}
            onError={(e) => {
              console.error("❌ Failed to load image:", fileUrl);
              // يمكن إضافة fallback هنا
            }}
            onLoad={() => {
              console.log("✅ Image loaded successfully:", fileUrl);
            }}
          />
        );
      } else if (isAudio) {
        return (
          <audio controls style={{ width: "100%", marginTop: "10px" }}>
            <source src={fileUrl} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        );
      } else {
        // For PDFs or other file types, show a download link
        return (
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: isLeft ? "#000" : "#fff",
              textDecoration: "underline",
              display: "block",
              marginTop: "10px",
            }}
          >
            Download File
          </a>
        );
      }
    }

    // ✅ إذا كان file من نوع IMedium بدون URL (من الخادم القديم)
    if (typeof file === 'object' && !file.url) {
      const fileUrl = "https://dev.3l-hareek.com/storage/media/messages/MessageFiles/" + file;
      const fileExtension = file.extension; // Get the file extension

      console.log("✅ Rendering legacy IMedium file:", fileUrl);

      // Check if the file is an image
      const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif'].includes(fileExtension || '');

      if (isImage) {
        return (
          <img
            src={fileUrl}
            alt="Uploaded file"
            style={{ maxWidth: "100%", borderRadius: "10px", marginTop: "10px" }}
            onError={(e) => {
              console.error("❌ Failed to load image:", fileUrl);
              // يمكن إضافة fallback هنا
            }}
            onLoad={() => {
              console.log("✅ Image loaded successfully:", fileUrl);
            }}
          />
        );
      } else if (isAudio) {
        return (
          <audio controls style={{ width: "100%", marginTop: "10px" }}>
            <source src={fileUrl} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        );
      } else {
        // For PDFs or other file types, show a download link
        return (
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: isLeft ? "#000" : "#fff",
              textDecoration: "underline",
              display: "block",
              marginTop: "10px",
            }}
          >
            Download File
          </a>
        );
      }
    }

    console.log("❌ Unknown file type:", file);
    return null;
  };

  return (
    // <div
    //   style={{
    //     display: "flex",
    //     flexDirection: isLeft ? "row" : "row-reverse",
    //     alignItems: "center",
    //     gap: "10px",
    //   }}
    // >
    /* <img
      src={"https://via.placeholder.com/40"}
      alt="User"
      style={{ width: "40px", height: "40px", borderRadius: "50%" }}
    /> */
    <div
      style={{
        backgroundColor: isLeft ? "#2d2d2d" : "rgb(43, 54, 58)",
        color: "#fff",
        padding: "10px",
        borderRadius: "10px",
        borderBottomLeftRadius: isLeft ? "0px" : "10px",
        borderBottomRightRadius: isLeft ? "10px" : "0px",
        maxWidth: "60%",
      }}
    >
      {/* <div style={{ fontWeight: "bold" }}>{name}</div> */}
      {text && <div dangerouslySetInnerHTML={{ __html: text }}></div>}
      {file && renderFile()}
      {status === "sending" && (
        <small className={styles["message-status"]}>جاري الإرسال...</small>
      )}
      {status === "failed" && (
        <small className={styles["message-status"]} style={{ color: "red" }}>
          فشل الإرسال
        </small>
      )}
      <div style={{ fontSize: "12px", color: isLeft ? "#666" : "#ddd" }}>
        {date}
      </div>
    </div>
    // </div>
  );
};

export default MessageCart;